import React, { useEffect, useState } from 'react'
import { Button, Grid, MenuItem, Paper, Select, Tooltip, Typography } from '@mui/material'
import clsx from 'clsx'
import useStyles from './style'
import { useNavigate, useSearchParams } from 'react-router'
import api from '../../lib/api'
import { patientData, setError, setOrderType } from '../../store/reducers/general'
import { changeBackend, changeDataProvider, setBreakTheGlass, setPreviousOrders } from '../../store/reducers/other'
import { useDispatch, useSelector } from 'react-redux'
import pck from '../../../package.json'

import { withStyles } from '@mui/styles'
import UserService from '../../lib/userService'
import moment from 'moment'

const Repairwit = require('../../assets/Icon - Reparatie wit.svg')

const HomePage = ({ classes }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [environmnents, setEnvironments] = useState([])
    const [selectedBackend, setBackend] = useState('geen')
    const [showSwitch, setSwitch] = useState(false)

    const [queryParameters] = useSearchParams()
    const other = useSelector((state) => state.other)

    useEffect(() => {
        initialize()
    }, [])

    /**
     * function to initialize the backend, locations and patients
     * 
     */
    async function initialize() {
        const initializedBackend = await backendInitialization();
        if (initializedBackend === null) {
            return null;
        } else {
            await patientInitialization();
        }
    }

    /**
     * get the authenticated podiatrist's name and email
     * (activated only in production)
     */
    function patientInitialization() {

        // save the patient number when given.
        const number = queryParameters.get('patient')
        if (number !== undefined && number !== null && number !== "") dispatch(patientData({ key: 'number', value: number }))

        const fetchTherapists = () => {
            api.therapists((rsp) => {
                dispatch(patientData({
                    key: 'therapist',
                    value: {
                        name: rsp.name,
                        email: rsp.email
                    }
                }))
            }, (error) => { dispatch(setError(error)) })
        }
        fetchTherapists()
        if (number === undefined || number === null) return
        api.patients(number,
            (data) => {
                const bday = moment(data.birthDate, 'YYYY/MM/DD').add(2, 'h')
                const lasts = [{ formattedName: '-' }]
                data.lasts.forEach(element => {
                    if (element.removed === null) {
                        lasts.push(element)
                    }
                })
                dispatch(patientData({ key: 'number', value: number }))
                dispatch(patientData({ key: 'lastName', value: data.lastName }))
                dispatch(patientData({ key: 'birthdate', value: bday }))
                dispatch(patientData({ key: 'gender', value: data.sex.toLowerCase() }))
                dispatch(patientData({ key: 'id', value: `${data.id}` }))
                dispatch(patientData({ key: 'initials', value: `${data.initials}` }))
                dispatch(patientData({ key: 'activeLasts', value: lasts }))
                if (lasts.length === 2) {
                    dispatch(patientData({ key: 'selectedLast', value: lasts[1].formattedName }))
                }

                api.getOrder(data.id, 'reparatie', (data) => {
                    const parsedData = []
                    data.forEach(element => {
                        parsedData.push(JSON.parse(element))
                    })
                    const orders = parsedData.sort((a, b) => b.senddate - a.senddate)
                    dispatch(setPreviousOrders(orders))
                }, (error) => {
                    dispatch(setError(error))
                })
            }, (error) => {
                if (error.response.status === 403) {
                    dispatch(setBreakTheGlass(true))
                } else {
                    dispatch(setError(error))
                }
            })
    }

    /**
     * Continue to order page.
     */
    function toRepair() {
        navigate('/repair')
        dispatch(setOrderType('Reparatie'))
    }

    /**
     * Change the selected backend
     *
     * @param {String} backend - selected backendprovider
     * @returns {Object} selected backend is returned as value.
     */
    async function backendInitialization() {
        let env = UserService.getEnvironments()
        let envSet = false

        setEnvironments(env)

        if (env.length === 1) {
            dispatch(changeBackend(env[0]))
            dispatch(changeDataProvider(env[0].key))

            api.setBackend(env[0])
            const toStore = { ...env[0], created: moment.now() }

            localStorage.setItem('environment', JSON.stringify(toStore))
            return env[0]
        }

        const redirectURL = queryParameters.get('url')

        if (redirectURL !== null) {
            env.forEach(element => {
                if (element.value === `https://${redirectURL}`) {
                    dispatch(changeBackend(element))
                    dispatch(changeDataProvider(element.key))

                    api.setBackend(element)
                    const toStore = { ...element, created: moment.now() }

                    localStorage.setItem('environment', JSON.stringify(toStore))
                    envSet = element
                }
            })
            if (envSet !== false) {
                return envSet
            }
        }

        if (localStorage.getItem('environment') !== null) {
            const backend = JSON.parse(localStorage.getItem('environment'))
            const createdMoment = moment(backend.created);

            let backendSet = false

            env.forEach(element => {
                if (element.value === backend.value && element.key === backend.key) {
                    if (moment().diff(createdMoment, 'days') <= 7) {
                        dispatch(changeBackend(backend))
                        dispatch(changeDataProvider(backend.key))

                        api.setBackend(backend)
                        backendSet = true
                    }
                }
            })
            if (backendSet) {
                return backend
            }
        }
        if (other.backend.key === '' && env.length > 1) {
            setSwitch(true)
        }
        return null
    }

    /**
     * Change the selected backend
     *
     *
     * @param {String} backend - selected backendprovider
     */
    function updateBackend(backend) {
        setBackend(backend)
        dispatch(changeBackend(backend))
        dispatch(changeDataProvider(backend.key))

        api.setBackend(backend)
        localStorage.setItem('environment', JSON.stringify(backend))

        setTimeout(() => {
            setSwitch(false)
            setBackend('geen')
        }, 500)
    }


    /**
     * open mail function
     */
    function openMail() {
        window.location.replace('mailto:helpdesk@podo-it.nl&subject=Missende omgeving')
    }

    return (
        showSwitch
            ? <Grid justifyContent="center" alignItems="center" container>
                <Grid item xs={8}>
                    <Paper>
                        <Grid container spacing={5}>
                            <Grid item xs={12}>
                                <Grid container justifyContent="center" alignItems="center">
                                    <Typography variant="h4">Kies een omgeving</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justifyContent="center" alignItems="center">
                                    <Select
                                        value={selectedBackend}
                                        onChange={event => updateBackend(event.target.value)}
                                    >
                                        <MenuItem disabled key={-1} value={'geen'}>Geen omgeving geselecteerd</MenuItem>
                                        {
                                            environmnents.map((order, index) =>
                                                <MenuItem key={index} value={order}>{order.key}</MenuItem>
                                            )
                                        }
                                    </Select>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} spacing={5}>
                                <Grid container justifyContent="center" alignItems="center">
                                    <Tooltip title="Klik om te mailen naar: helpdesk@podo-it.nl">
                                        <Button variant='outlined' onClick={() => openMail()}>Help, ik mis een omgeving</Button>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            {/** SPACING */}
                            <Grid item xs={12}>
                                <Grid container justifyContent="center" alignItems="center"></Grid>
                            </Grid>

                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
            : <Grid justifyContent="center" alignItems="center" container spacing={5}>
                <Grid item xs={4} onClick={toRepair}>
                    <Grid
                        container
                        className={clsx([classes.paper, classes.secondary])}
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <img className={classes.svgPaper} src={Repairwit} alt="Wender Logo" />
                        <Typography variant="h6" className={classes.paperText}>Reparatie</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} spacing={5}>
                    <Grid className={classes.version} container justifyContent="center" alignItems="center">
                        <Tooltip title="Klik om te wisselen van omgeving">
                            <Button
                                variant="contained"
                                color='primary'
                                className={classes.backButton}
                                onClick={() => setSwitch(true)}
                            >Wissel omgeving: {other.backend.key}</Button>
                        </Tooltip>
                    </Grid>
                </Grid>
                <Grid item xs={12} spacing={5}>
                    <Grid className={classes.version} container justifyContent="center" alignItems="center">
                        <Typography className={classes.versionText} variant="caption" align='center'>v{pck.version}</Typography>
                    </Grid>
                </Grid>
            </Grid>
    )
}

export default withStyles(useStyles)(HomePage)
